/* global axios */
import ApiClient from '../ApiClient';

class NexceoTodaySiteVisitsAPI extends ApiClient {
  constructor() {
    super('nexceo/today_site_visits', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new NexceoTodaySiteVisitsAPI();
